<template>
  <ok-cancel-modal
    v-if="showSelectModal"
    :okButton="$t('commons.save')"
    :cancelButton="$t('commons.cancel')"
    v-on:cancel="showSelectModal = false"
    v-on:ok="emitPairSelected"
    :title="$t('explorer.correlationSelectTitle')">
    <div slot="body">
      <label-select
        :options="getSelectOptions()"
        :value="selectedPair"
        v-on:input="onPairSelectChange"
        :error="selectError"
        :disabled="false">
      </label-select>
    </div>
  </ok-cancel-modal>
</template>

<script>

import LabelSelect from '@/components/shared/forms/LabelSelect';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';

export default {
  components: {
    OkCancelModal,
    LabelSelect
  },
  props: {
    variables: {
      type: Array,
      default: () => []
    },
    variablePairs: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showSelectModal: false,
      selectedPair: null,
      selectError: false
    };
  },
  methods: {
    show () {
      this.showSelectModal = true;
    },
    getSelectOptions () {
      let options = [];
      for (let i = 0; i < this.variablePairs.length; i++) {
        let currentPair = this.variablePairs[i];
        options.push({
          label: this.findLabelById(parseInt(currentPair.x)) + ' - ' + this.findLabelById(parseInt(currentPair.y)),
          value: currentPair
        });
      }
      return options;
    },
    findLabelById (id) {
      const correlatedVariable = this.variables.find(variable => {
        return variable.metadata.id === id;
      });
      return correlatedVariable.metadata.label;
    },
    onPairSelectChange (e) {
      if (e) {
        this.selectError = false;
        this.selectedPair = e;
      }
    },
    emitPairSelected () {
      if (this.selectedPair != null) {
        this.$emit('onPairSelected', this.selectedPair);
        this.showSelectModal = false;
      } else {
        this.selectError = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables.scss";

  .select {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/explorer/correlation/VariablePairSelectModal.vue